<template>
  <div>
    <p>Choose your character</p>

    <div class="list-game-choices">
      <button
        v-for="character in $store.state.currentGame.characters"
        :key="character.name"
        :disabled="character.disabled"
        @click="$store.commit('setCurrentCharacter', character)">
        <figure>
          <img :src="getCharacterButtonBgImage(character)"
            :alt="character.name" />
          <figcaption>{{character.name}}</figcaption>
        </figure>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$store.commit('setShowLogo', true);
  },
  methods: {
    getCharacterButtonBgImage: character => `${character.avatar.fields.file.url}?q=50`,
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 150px;
}
</style>
